export enum ErrorMessage {
  GENERIC = 'form_generic_error',
  FORM_INVALID = 'form_invalid',
  CONTENT_NON_EXISTENT_ERROR = 'content_non_existent_error',
  ASSET_NON_EXISTENT_ERROR = 'asset_non_existent_error',
  NON_EXISTENT_MERCH_ASSOCIATED_CONTENT = 'form_merch_associated_content_non_existent_content_error',
  CONTENT_REQUEST_ERROR = 'content_request_error',
  CONTENT_URI_NOT_ACCEPTED_ERROR = 'content_uri_not_accepted',
}
